import { Vector3 } from "three";
import { Padding } from "./Padding";

export class VerticeHelper {
    static split9Quad(v1: Vector3, v2: Vector3, v3: Vector3, v4: Vector3, padding: Padding): Vector3[] {
        const u: Vector3 = v2.clone().sub(v1).normalize();
        const v: Vector3 = v4.clone().sub(v1).normalize();

        const vertices: Vector3[] = [
            v1.clone(),
            v1.clone().add(u.clone().multiplyScalar(padding.left)),
            v2.clone().sub(u.clone().multiplyScalar(padding.right)),
            v2.clone(),

            v1.clone().add(v.clone().multiplyScalar(padding.top)),
            v1.clone().add(u.clone().multiplyScalar(padding.left)).add(v.clone().multiplyScalar(padding.top)),
            v2.clone().sub(u.clone().multiplyScalar(padding.right)).add(v.clone().multiplyScalar(padding.top)),
            v2.clone().add(v.clone().multiplyScalar(padding.top)),

            v4.clone().sub(v.clone().multiplyScalar(padding.bottom)),
            v4.clone().add(u.clone().multiplyScalar(padding.left)).sub(v.clone().multiplyScalar(padding.bottom)),
            v3.clone().sub(u.clone().multiplyScalar(padding.right)).sub(v.clone().multiplyScalar(padding.bottom)),
            v3.clone().sub(v.clone().multiplyScalar(padding.bottom)),

            v4.clone(),
            v4.clone().add(u.clone().multiplyScalar(padding.left)),
            v3.clone().sub(u.clone().multiplyScalar(padding.right)),
            v3.clone(),
        ];

        return vertices;
    }
}
